export const PlayIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="21"
    height="21"
    viewBox="0 0 21 21"
    fill="none"
  >
    <path
      d="M18.6563 9.17441L7.4 2.28848C7.21022 2.17227 6.99287 2.10883 6.77037 2.10471C6.54788 2.10059 6.32832 2.15594 6.13438 2.26504C5.94227 2.37245 5.78225 2.52908 5.67075 2.71884C5.55926 2.9086 5.50032 3.12464 5.5 3.34473V17.115C5.50145 17.4452 5.63393 17.7612 5.86833 17.9937C6.10273 18.2262 6.41986 18.3561 6.75 18.3549C6.98043 18.3548 7.20639 18.2913 7.40313 18.1713L18.6563 11.2854C18.8371 11.1751 18.9866 11.0202 19.0904 10.8355C19.1941 10.6508 19.2486 10.4425 19.2486 10.2307C19.2486 10.0188 19.1941 9.81055 19.0904 9.62585C18.9866 9.44115 18.8371 9.28623 18.6563 9.17598V9.17441ZM6.75 17.1002V3.35488L17.9867 10.2299L6.75 17.1002Z"
      fill="white"
    />
  </svg>
);
